// extracted by mini-css-extract-plugin
export default {"companyContainer":"QK-z","companyImage":"RK-z","container":"SK-z","heading":"TK-z","darkText":"UK-z","smallHeading":"VK-z","darkBackground":"WK-z","whiteBackground":"XK-z"};